import React, { useState } from 'react';

import PlacesAutocomplete from 'react-places-autocomplete';
import { Loader2, Search } from 'lucide-react';

import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

const GoogleBusinessSearch = ({ id, onSelect, countries, disabled }) => {
	const [query, setQuery] = useState('');

	if (!window.google?.maps?.places) return null;

	const handleSelect = (description, placeId) => {
		setQuery(description);
		if (placeId) onSelect(placeId);
	};

	return (
		<PlacesAutocomplete
			value={query}
			onChange={setQuery}
			onSelect={handleSelect}
			searchOptions={{
				types: ['establishment'],
				componentRestrictions: { country: countries },
			}}
		>
			{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
				<div className="relative">
					<Search
						className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
						aria-hidden="true"
					/>
					<Input
						{...getInputProps({
							id,
							placeholder: 'Search your business name to fill in the form',
							disabled,
							className: 'pl-9',
						})}
					/>
					{(loading || suggestions.length > 0) && (
						<div className="absolute z-50 mt-1 w-full overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md">
							{loading && (
								<div className="flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground">
									<Loader2 className="size-4 animate-spin" />
									Searching…
								</div>
							)}
							{suggestions.map((suggestion) => (
								<div
									{...getSuggestionItemProps(suggestion, {
										className: cn(
											'cursor-pointer px-3 py-2 text-sm',
											suggestion.active && 'bg-accent text-accent-foreground',
										),
									})}
									key={suggestion.placeId}
								>
									<span className="font-medium">
										{suggestion.formattedSuggestion.mainText}
									</span>
									<span className="ml-1 text-muted-foreground">
										{suggestion.formattedSuggestion.secondaryText}
									</span>
								</div>
							))}
							{suggestions.length > 0 && (
								<p className="border-t px-3 py-1.5 text-right text-xs text-muted-foreground">
									Powered by Google
								</p>
							)}
						</div>
					)}
				</div>
			)}
		</PlacesAutocomplete>
	);
};

export default GoogleBusinessSearch;
